export default "__VITE_ASSET__QyS_r5s2__"